/**
 * 判定関連のユーティリティ関数
 */

/**
 * EvidenceViewer の normalizeJudgment と同じ基準でラベルを正規化する
 */
export function normalizeJudgmentLabel(status: string): string {
  if (!status) return "";
  if (status.includes("OK")) return "OK";
  if (status.includes("手順NG")) return "手順NG";
  if (status.includes("結果NG")) return "結果NG";
  return status;
}

/**
 * 人間判定とAI判定が両方あり、正規化後に異なるか
 */
export function isHumanAiJudgmentMismatch(
  human: string | null | undefined,
  ai: string | null | undefined
): boolean {
  if (human == null || human === "" || ai == null || ai === "") {
    return false;
  }
  return (
    normalizeJudgmentLabel(String(human)) !==
    normalizeJudgmentLabel(String(ai))
  );
}

/**
 * script_test_run_result.value 内の tag_analysis から判定不一致かどうか
 */
export function apiTestResultHasHumanAiJudgmentMismatch(result: {
  scriptTestRunResult: { value: string };
}): boolean {
  try {
    const raw = result.scriptTestRunResult.value;
    if (!raw || raw === "undefined" || raw === "null") return false;
    const parsed = JSON.parse(raw);
    const ta = parsed?.tag_analysis;
    if (!ta) return false;
    return isHumanAiJudgmentMismatch(ta.human_judgment, ta.ai_judgment);
  } catch {
    return false;
  }
}

/**
 * 判定に応じた色を取得
 * @param judgment - 判定文字列
 * @returns 色コード
 */
export const getJudgmentColor = (judgment: string): string => {
  switch (judgment) {
    case 'OK':
      return '#4caf50'; // 緑
    case '手順NG':
      return '#ff9800'; // オレンジ
    case '結果NG':
      return '#f44336'; // 赤
    case '未評価':
      return '#9e9e9e'; // グレー
    default:
      return '#9e9e9e';
  }
};

/**
 * 判定結果に応じた背景色を取得（透明度付き）
 * @param judgment - 判定結果
 * @param opacity - 透明度（0-1）
 * @returns RGBAカラー文字列
 */
export const getJudgmentBackgroundColor = (judgment: string, opacity: number = 0.1): string => {
  switch (judgment) {
    case 'OK':
      return `rgba(76, 175, 80, ${opacity})`; // 緑 (#4caf50)
    case '手順NG':
      return `rgba(255, 152, 0, ${opacity})`; // オレンジ (#ff9800)
    case '結果NG':
      return `rgba(244, 67, 54, ${opacity})`; // 赤 (#f44336)
    case '未評価':
      return `rgba(158, 158, 158, ${opacity})`; // グレー (#9e9e9e)
    default:
      return `rgba(158, 158, 158, ${opacity})`;
  }
};
